<template>
  <div class="col-md-5 order-md-2 order-1">
    <div class="order-review">
      <table>
        <tbody>
          <template v-for="(cart, index) in cartData.getCartItems">
            <tr>
              <td class="thumb">
                <div class="img-cont">
                  <img :src="cart.image" alt="" />
                  <!-- <span class="crl-count">1</span> -->
                </div>
              </td>
              <td>
                <h5 v-html="cart.name"></h5>
                <p v-html="cart.description"></p>
                <!-- Show quantity only when double parameter is present -->
                <p v-if="route.query.double === 'true' && cart.quantity > 1" style="color: #41a823; font-weight: 600;">
                  <i class="ri-gift-line"></i> Quantity: {{ cart.quantity }} (Buy 2 Get 1 Free!)
                </p>
              </td>
              <td class="text-end">
                <span class="price"
                  >${{
                    ((cart.price * cart.quantity).toFixed(2)).toLocaleString("en-US")
                  }}</span
                >
                <a
                  href="javascript: ;"
                  @click="cartData.removeFromCart(cart)"
                  class="remove"
                  ><i class="ri-delete-bin-line"></i
                ></a>
              </td>
            </tr>
          </template>
          <template v-if="cartData.getCartCoupon == ''">
            <tr>
              <td colspan="3">
                <div class="coupon">
                  <input
                    type="text"
                    v-model="coupon_code"
                    name="coupon_code"
                    class="input-text"
                    id="coupon_code"
                    value=""
                    :placeholder="props.translationText.text.enterCode"
                  />
                  <button
                    type="button"
                    @click="applyCode"
                    class="btn btn-dark rc"
                    name=""
                  >
                    {{ props.translationText.text.apply }}
                  </button>
                </div>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="3" style="text-align: left">
                <div class="default">
                  <span style="color: #41a823"
                    ><i class="ri-price-tag-3-fill"></i>
                    {{ cartData.getCartCouponCode }}
                    {{ props.translationText.text.codeApplied }}</span
                  >
                  <a href="javascript: ;" @click="cartData.resetApplyCoupon()"
                    ><i class="ri-close-line"></i
                  ></a>
                </div>
                <!-- <div class="msg">
                                        <h6> Using a discount coupon may void free shipping options. </h6>
                                        </div> -->
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <table>
        <tfoot>
          <tr>
            <td>{{ props.translationText.text.subtotal }}</td>
            <td>${{ cartData.getCartTotalPrice }}</td>
          </tr>
          <!-- <tr>
                                <td><div class="cde">Discount <i class="ri-price-tag-3-fill"></i> Prezerv Silver Retail Discount</div></td>
                                <td>- $24.87</td>
                            </tr> -->
          <tr>
            <td>{{ props.translationText.text.netShipping }}</td>
            <td>
              ${{ cartData.getShippingRate }}

              <template v-if="cartData.getShippingDiscount > 0"> - ({{
                cartData.getShippingDiscount
              }})</template>
            </td>
          </tr>

          <tr>
            <td>{{ props.translationText.text.shipping_tax }}</td>
            <td>
              ${{ cartData.getShippingTax }}

              <!-- <template v-if="cartData.getShippingDiscount > 0"> - ({{
                cartData.getShippingDiscount
              }})</template> -->
            </td>
          </tr>

          <tr>
            <td>{{ props.translationText.text.tax }}</td>
            <td>${{ cartData.getTaxTotal }}</td>
          </tr>
          <tr class="total">
            <td>
              <strong>{{ props.translationText.text.total }}:</strong>
            </td>
            <td>
              <strong>${{ cartData.getCartTotalNetPrice }}</strong>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="text-align: left" v-if="hideCLMText">
              <div v-if="showCheckoutMsg">
                <p class="imp-heading-task">Made in a GMP Certified Facility</p>
                <p class="imp-heading-task">Clinically Endorsed by Dr. Willy Tsaku, MD 
                  <a href="javascript:;" @click="openModal()">
                    <img src="/assets/images/teams/willyt.png" width="41px">
                  </a>
                </p>
              </div>

            <div v-if="showCheckoutMsg" class="gurantee-text">
              <strong>Why choose CymSlim?</strong>

              <span class="gurantee-text-btn" style="width: 12%; float: right; display: block;">
                <img src="/assets/images/checkout/256_bit_secure.png" alt="Secure Badge" />
              </span>

              <br /><br />

              <ul style="padding-left: 18px; margin: 0;">
                <li>
                  <strong>Try it for 60 days, get visibly leaner or 100 % of your money back.</strong><br />
                  Keep the products, no return needed. Just email our support and we'll issue an instant refund.<br  />
                  <strong>Clinically-backed formula transparency</strong><br />
                  <strong>Formulated with evidence-based ingredients:</strong><br />
                  Produced in GMP-certified facility and GMO Free</br>
                  <strong>Glutathione Precursors:</strong> Supports detoxification, reduces inflammation, and boosts fat metabolism to target fat and preserve muscle mass.<br />
                  <strong>UneVie Delivery System:</strong> Ensures effective nutrient transport directly to the mitochondria for enhanced fat-burning and nutrient absorption<br />
                </li><br />
                <li>
                  <strong>{{ props.translationText.text.chksidebarPoint3 }}</strong><br />
                  {{ props.translationText.text.chksidebarPoint4 }}
                </li><br />
                <li>
                  <strong>{{ props.translationText.text.chksidebarPoint5 }}</strong><br />
                  {{ props.translationText.text.chksidebarPoint6 }}<br />
                  <strong>{{ props.translationText.text.chksidebarPoint7 }}</strong><br />
                  {{ props.translationText.text.chksidebarPoint8 }}
                </li>
              </ul>
            </div>
            
            <div v-if="!showCheckoutMsg" class="gurantee-text">
              <strong>{{ props.translationText.text.chksidebarTitle }}</strong>

              <span class="gurantee-text-btn" style="width: 12%; float: right; display: block;">
                <img src="/assets/images/checkout/256_bit_secure.png" alt="Secure Badge" />
              </span>

              <br /><br />

              <ul style="padding-left: 18px; margin: 0;">
                <li>
                  <strong>{{ props.translationText.text.chksidebarPoint1 }}</strong><br />
                  {{ props.translationText.text.chksidebarPoint2 }}
                </li><br />
                <li>
                  <strong>{{ props.translationText.text.chksidebarPoint3 }}</strong><br />
                  {{ props.translationText.text.chksidebarPoint4 }}
                </li><br />
                <li>
                  <strong>{{ props.translationText.text.chksidebarPoint5 }}</strong><br />
                  {{ props.translationText.text.chksidebarPoint6 }}<br />
                  <strong>{{ props.translationText.text.chksidebarPoint7 }}</strong><br />
                  {{ props.translationText.text.chksidebarPoint8 }}
                </li>
              </ul>
            </div>
            <div>
              <img width="15%" src="/assets/images/checkout/nortan.png" /> <img width="15%"  src="/assets/images/checkout/mcafe.png" /> 
            </div>
          </td>

          </tr>
          <!-- <tr>
            <td>
              <small>{{ props.translationText.text.monthlyPE }}</small>
            </td>
            <td>
              <small>${{ cartData.getCartTotalNetPrice }}</small>
            </td>
          </tr> -->
        </tfoot>
      </table>
    </div>
  </div>
  <div
    class="modal fade"
    id="myModalBio"
    tabindex="-1"
    aria-labelledby="cartModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog about-pop">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <img src="/assets/images/teams/willyt.png" />
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ri-close-line"></i>
          </button>

          <h4 class="modal-title">WILLY TSAKU, MD</h4>
        </div>
        <div class="modal-body">
          <p>My journey into health care began in 2000, when I learned the sobering statistic that 15M children were orphans of AIDS in Africa. It was unfathomable. In the age of modern medical, scientific and technological advancements, how is this even possible? I knew the sad truth that developing countries can’t afford the exorbitant costs associated with pharmaceutical drugs and don’t always have adequate access to health care professionals.</p>
        </div>
        <div class="modal-footer">          
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import { ref, computed, defineProps, onMounted } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import { useLoginStore } from "../../stores/login";
import { useCartStore } from "../../stores/cart";

const props = defineProps(["translationText", "baseURL"]);
const showCheckoutMsg = ref(false);
const hideCLMText = ref(true);
const cartData = useCartStore();
//const cartItemData = ref([])
const userLogin = useLoginStore();
const route = useRoute();
const coupon_code = ref();
const quantity = ref(1);
const decreaseQty = () => {
  if (quantity.value > 1) {
    quantity.value--;
  }
};

const increaseQty = () => {
  quantity.value++;
};
const cartItem = {
  id: 1,
};
const openCartModal = () => {
  cartData.addToCart(cartItem);
  $("#cartModal").modal("show");
};
const applyCode = () => {

  if(cartData.getCartPurchaseType == true){
    swal({
        position: "top-end",
        icon: "error",
        title: "Autoship discount price is already applied.",
        button: false,
        timer: 2500,
      });
  }
  else{
    axios
    .post(
      props.baseURL + "discount",
      { user: userLogin.getUserUserData, name: coupon_code.value,qty:cartData.getCartCountQuantity, product:cartData.getCartItems },
      {
        validateStatus: function (status) {
          return status < 500; // Resolve only if the status code is less than 500
        },
      }
    )
    .then((response) => {
      //allStates.value = response.data.states;
      
      console.log("getCartCoupon", cartData.getCartCoupon);
      console.log("response.data", response.data);
      console.log("response.data.states", response.status);
      if(response.status == 200){
        cartData.applyCoupon(response.data, coupon_code.value);
        swal({
          position: "top-end",
          icon: "success",
          title: "Coupon code applied",
          button: false,
          timer: 2500,
        });
      } else {
        swal({
          position: "top-end",
          icon: "error",
          title: response.data.error,
          button: false,
          timer: 2500,
        });
      }
    })
    .catch((error) => {
      swal({
        position: "top-end",
        icon: "error",
        title: "Invalid coupon code",
        button: false,
        timer: 2500,
      });
    });

  }
  
};
onMounted(() => {      
      const productParam = route.query.product;
      if (productParam == '16' || productParam == 16) {
        showCheckoutMsg.value = false;
        hideCLMText.value = false;
      }
});

const removeApplyCode = () => {
  cartData.resetApplyCoupon();
  coupon_code.value = "";
  isCoupnApply.value = false;
};
const openModal = () => {  
  window.$("#myModalBio").modal("show");
};
</script>
<style>
p.imp-heading-task{
  font-weight: 800;
}
</style>
